module.exports = __webpack_public_path__ + "img/uk-gc-4.40655a4d.png";